export const removeWhichCookies = () => {
  cookieNames.forEach((cookie) => {
    document.cookie = `${cookie}=; domain=.internal.which.co.uk; expires=Thu, 01 Jan 1970 00:00:01 GMT; Path=/;`
    document.cookie = `${cookie}=; domain=.which.co.uk; expires=Thu, 01 Jan 1970 00:00:01 GMT; Path=/;`
    // Remove cookies for localhost development
    document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; Path=/;`
  })
}

///////// IMPLEMENTATION /////////

const cookieNames = [
  'blaize_session',
  'blaize_tracking_id',
  'identity.analytics_flag.logged_in',
  'identity.cdn.logged_in',
  'contact_ID',
  'contact_ID.analytics_flag',
  'master_id',
  'master_id.analytics_flag',
  'sessionId',
]
